module.exports = __webpack_public_path__ + "img/line-grey.71250d05.svg";